<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import itemsAPI from "../../../services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist"
import Swal from "sweetalert2";

/**


 * Form elements component
 */
export default {
  page: {
    title: "Estándares",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    DontExist,
  },
  data() {
    return {
      title: "Editar estándar",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Editar estándar",
          active: true,
        },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID:
        this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading: true,
      loading2: false,

      estandarData: {
        sequence: null,
        description: null,
        value: null,
        obligatory_UPA: null,
        status: null,
        url: null,
        obligatory_groupI: null,
        obligatory_groupII: null,
        obligatory_groupIII: null,
      },
    };
  },

  methods: {
    getEstandar() {
      itemsAPI
        .getItems(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          console.log(response);
          this.estandarData = {
            sequence: response.sequence,
            description: response.description,
            value: response.value,
            obligatory_UPA: response.obligatory_UPA,
            status: response.status,
            url: response.url,
            obligatory_groupI: response.obligatory_groupI,
            obligatory_groupII: response.obligatory_groupII,
            obligatory_groupIII: response.obligatory_groupIII,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    update() {
      itemsAPI
        .updateItems(this.$route.params.id, {
          sequence: this.estandarData.sequence,
          description: this.estandarData.description,
          value: this.estandarData.value,
          obligatory_UPA: this.estandarData.obligatory_UPA,
          status: this.estandarData.status,
          url: this.estandarData.url,
          obligatory_groupI: this.estandarData.obligatory_groupI,
          obligatory_groupII: this.estandarData.obligatory_groupII,
          obligatory_groupIII: this.estandarData.obligatory_groupIII,
        })
        .then((response) => {
          Swal.fire({
            title: "ítem actualizado con exito!",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          this.$router.go(-1);
          console.log(response);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getEstandar();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div v-if="!loading && !loading2 && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h4 class="header-title mb-4">Editar</h4>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>

              <div class="row">
                <div class="col-3"></div>
                <div class="col-md-6">
                  <div class="card-body">
                    <form class="form-horizontal" role="form">
                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Item"
                        label-for="sequence"
                      >
                        <b-form-input
                          type="text"
                          id="sequence"
                          placeholder=""
                          v-model="estandarData.sequence"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Nombre"
                        label-for="description"
                      >
                        <b-form-input
                          type="text"
                          id="description"
                          required
                          v-model="estandarData.description"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Valor"
                        label-for="value"
                      >
                        <b-form-input
                          type="tel"
                          id="value"
                          placeholder=""
                          v-model="estandarData.value"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio UPA"
                        label-for="obligatory_UPA"
                      >
                        <select
                          id="obligatory_UPA"
                          class="form-control"
                          v-model="estandarData.obligatory_UPA"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Estado"
                        id="estado"
                        label-for="status"
                      >
                        <select
                          id="estado"
                          class="form-control"
                          v-model="estandarData.status"
                        >
                          <option :value="1">Activo</option>
                          <option :value="0">Inactivo</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="URL"
                        id="url"
                        label-for="url"
                      >
                        <b-form-input
                          type="text"
                          id="url"
                          placeholder=""
                          v-model="estandarData.url"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio grupo 1"
                        label-for="obligatory1"
                      >
                        <select
                          id="obligatory1"
                          class="form-control"
                          v-model="estandarData.obligatory_groupI"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio grupo 2"
                        label-for="obligatory2"
                      >
                        <select
                          id="obligatory2"
                          class="form-control"
                          v-model="estandarData.obligatory_groupII"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio grupo 3"
                        label-for="obligatory3"
                      >
                        <select
                          id="obligatory3"
                          class="form-control"
                          v-model="estandarData.obligatory_groupIII"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <div class="form-group text-right m-b-0">
                        <button class="btn btn-primary" @click="update" type="button">
                          Guardar
                        </button>
                        <button
                          type="button"
                          @click="goBack"
                          class="btn btn-secondary m-l-5 ml-1"
                        >
                          Cancelar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-1"></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="!loading && !loading2 && classificationID === 5">
          <DontExist text="se debe calificar la empresa para poder proceder." />
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
